export class DatabaseSyncAction {
  public id: number;
  public entityType: EntityType;
  public entityID: string;
  public action: Action;

  /**
   *
   */
  constructor(
    entityType: EntityType,
    entityID: string,
    action: Action,
    id?: number
  ) {
    this.action = action;
    this.entityID = entityID;
    this.entityType = entityType;
    this.id = id;
  }
}

export enum EntityType {
  Property,
  Paddock,
  Fence,
  NpvReport,
  TopexReport,
  EnterpriseReport,
  ForestDescriptionReport,
  PineEconomicAnalysisReports,
  PeatDefault
}

export enum Action {
  Insert,
  Update,
  Remove
}
